module.exports = __webpack_public_path__ + "static/media/icon-info.372bf471.svg";